<template>
    <div>
        <!-- Header section with logo -->
        <section class="simple-nav">
            <div class="simplenav_wrap">
                <div class="simplenav_flex">
                    <div class="nav-left-div">
                        <a href="#" class="link-block w-inline-block">
                            <img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-545">
                        </a>
                    </div>
                </div>
            </div>
            <div class="nav-shadow"></div>
            <div class="mobile-nav-div">
                <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-mobile w-nav">
                    <a href="#" class="brand home w-nav-brand">
                        <img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-551">
                    </a>
                </div>
            </div>
        </section>

        <!-- Progress indicator -->
        <section class="progress-section">
            <div class="progress-container">
                <div class="step-indicator">
                    <div class="step-text" v-if="active_el === 0">Verify Address - Step <strong>3</strong> of <strong>5</strong></div>
                    <div class="step-text" v-else-if="active_el === 1">Verify Phone - Step <strong>4</strong> of <strong>5</strong></div>
                    <div class="step-text" v-else-if="active_el === 2">Verify Email - Step <strong>5</strong> of <strong>5</strong></div>
                </div>
            </div>
        </section>

        <!-- Main content section -->
        <div class="form-section">
            <div class="questions-div" style="padding-top: 0%;">
                <!-- Address Verification Step -->
                <div class="question-container" v-if="active_el === 0">
                    <div class="question-category">
                        <div class="enroll-form-header-text">SHIPPING INFO</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">Verify your shipping address</div>
                        <div class="form-subs">We need to confirm your shipping address to ensure accurate delivery of your medications.</div>
                        
                        <!-- Address Validation Loading State -->
                        <div v-if="validatingAddress" class="validation-loading">
                            <div>Validating your address...</div>
                        </div>
                        
                        <!-- Address Invalid - Show Suggestions -->
                        <div v-else-if="!addressValid && addressSuggestions" class="address-suggestions">
                            <div class="suggestion-header">We found a suggested correction for your address:</div>
                            <div class="suggested-address">
                                <div><strong>Suggested Address:</strong></div>
                                <div>{{ addressSuggestions.address_line_1 }}</div>
                                <div v-if="addressSuggestions.address_line_2">{{ addressSuggestions.address_line_2 }}</div>
                                <div>{{ addressSuggestions.city }}, {{ addressSuggestions.state }} {{ addressSuggestions.zip }}</div>
                            </div>
                            <div class="button-group">
                                <button 
                                    type="button" 
                                    class="form-button w-button"
                                    @click="acceptSuggestedAddress"
                                    :disabled="savingAddress"
                                >
                                    {{ savingAddress ? 'Saving...' : 'Use Suggested Address' }}
                                </button>
                                <button 
                                    type="button" 
                                    class="form-button secondary w-button"
                                    @click="showAddressForm = true"
                                >
                                    Enter Different Address
                                </button>
                            </div>
                        </div>
                        
                        <!-- Manual Address Entry Form -->
                        <div v-if="showAddressForm || (!addressValid && !addressSuggestions)" class="felix-form-block w-form">
                            <form @submit.prevent="validateAndSaveAddress">
                                <div class="address-form-row">
                                    <div class="address-field">
                                        <input 
                                            class="text-field-59 w-input text-field-59999" 
                                            v-model="addressForm.address_line_1" 
                                            maxlength="256" 
                                            name="Address-1" 
                                            placeholder="Address" 
                                            type="text" 
                                            required
                                        >
                                    </div>
                                    <div class="apt-field">
                                        <input 
                                            class="text-field-59 w-input text-field-59999" 
                                            maxlength="256" 
                                            v-model="addressForm.address_line_2" 
                                            name="Apt-2" 
                                            placeholder="Apt #" 
                                            type="text"
                                        >
                                    </div>
                                </div>
                                <div class="address-form-row">
                                    <div class="city-field">
                                        <input 
                                            v-model="addressForm.city" 
                                            class="text-field-59 w-input text-field-59999" 
                                            placeholder="City" 
                                            required
                                        />
                                    </div>
                                    <div class="state-field">
                                        <select 
                                            name="State" 
                                            required 
                                            v-model="addressForm.state"  
                                            class="text-field-59 w-input text-field-59999"
                                        >
                                            <option value="" disabled>State</option>
                                            <option v-for="(value, key) in allStates" :value="value" :key="value">{{ key }}</option>
                                        </select>
                                    </div>
                                    <div class="zip-field">
                                        <input 
                                            v-model="addressForm.zip" 
                                            placeholder="ZIP Code" 
                                            class="text-field-59 w-input text-field-59999" 
                                            required
                                        />
                                    </div>
                                </div>
                                <input 
                                    type="submit" 
                                    class="form-button w-button" 
                                    :value="savingAddress ? 'Validating...' : 'Validate & Save Address'"
                                    :disabled="savingAddress"
                                >
                                
                                <div v-if="showAddressSuccess" class="success-message">
                                    <div>Address updated successfully!</div>
                                </div>
                                
                                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
                            </form>
                        </div>
                        
                        <!-- Address Valid - Show Confirmation -->
                        <div v-if="addressValid && !showAddressForm" class="address-confirmed">
                            <div class="confirmation-header">✓ Your address has been verified</div>
                            <div class="auto-advance-message">Automatically advancing to phone verification...</div>
                        </div>
                    </div>
                    
                </div>

                <!-- Phone Change Form -->
                <div class="question-container" v-if="active_el === 1 && isChangingPhone">
                    <div class="question-category">
                        <div class="enroll-form-header-text">CONTACT INFO</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">What is your mobile phone number?</div>
                        <div class="form-subs">Enter the best phone to reach you on just in case your doctor has any questions regarding your medical information.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="updatePhoneNumber">
                                <div class="phone-entry-div felix">
                                    <input v-model="newPhone.area" ref="areaInput" class="phone-number-field-3 _1 form w-input" maxlength="3" placeholder="(000)" type="text" @input="validatePhoneInput($event, 'area')">
                                    <div class="text-block-1388">-</div>
                                    <input v-model="newPhone.prefix" ref="prefixInput" class="phone-number-field-3 form w-input" maxlength="3" placeholder="000" type="text" @input="validatePhoneInput($event, 'prefix')">
                                    <div class="text-block-1388">-</div>
                                    <input v-model="newPhone.line" ref="lineInput" class="phone-number-field-3 _2 form w-input" maxlength="4" placeholder="0000" type="text" @input="validatePhoneInput($event, 'line')">
                                </div>
                                <div class="button-group">
                                    <input type="submit" class="form-button w-button" :value="updatingPhone ? 'Updating...' : 'Update Phone Number'" :disabled="!isValidPhone || updatingPhone">
                                </div>
                                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="cancelPhoneChange()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">&lt; Cancel</div>
                        </a>
                    </div>
                </div>

                <!-- Phone Verification -->
                <div class="question-container" v-if="active_el === 1 && !isChangingPhone">
                    <div class="question-category">
                        <div class="enroll-form-header-text">CONTACT INFO</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">Verify your mobile phone number</div>
                        <div class="form-subs">enter the 4-digit sent to <span class="phone-number-span">{{ user.phone }}</span></div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handlePhoneVerification">
                                <div class="phone-verify-div">
                                    <input v-for="(digit, index) in 4" :key="index" v-model="phoneOtpDigits[index]" class="text-field-60 w-input" maxlength="1" type="text" @input="handleOtpInput($event, index, 'phone')" @keydown="handleKeydown($event, index, 'phone')" ref="phoneInputs" :disabled="verifyingPhone">
                                </div>
                                <a href="#" class="link-72" @click.prevent="resendCode('phone')" v-if="!phoneResendTimer" :class="{ 'disabled': phoneCodeSent }">
                                    Resend code
                                </a>
                                <span v-else class="timer text-muted">Resend available in {{ phoneResendTimer }}s</span>
                                <a href="#" class="link-71" @click.prevent="changePhone">Change my mobile number</a>
                                <input type="submit" class="form-button w-button" :value="verifyingPhone ? 'Verifying...' : 'Next →'" :disabled="!isPhoneOtpComplete || verifyingPhone">
                                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="skipPhoneVerification()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">Skip verification -></div>
                        </a>
                    </div>
                </div>

                <!-- Email Change Form -->
                <div class="question-container" v-if="active_el === 2 && isChangingEmail">
                    <div class="question-category">
                        <div class="enroll-form-header-text">CONTACT INFO</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">Please enter your email</div>
                        <div class="form-subs">We will send you confirmation of approval & discount offers.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="updateEmailAddress">
                                <input v-model="newEmail" class="text-field-59 email form w-input" maxlength="256" placeholder="Enter your email" type="email" required>
                                <input type="submit" class="form-button w-button" :value="updatingEmail ? 'Updating...' : 'Update Email Address'" :disabled="!isValidEmail || updatingEmail">
                                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="cancelEmailChange()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">&lt; Cancel</div>
                        </a>
                    </div>
                </div>

                <!-- Email Verification -->
                <div class="question-container" v-if="active_el === 2 && !isChangingEmail">
                    <div class="question-category">
                        <div class="enroll-form-header-text">CONTACT INFO</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">Verify your email address</div>
                        <div class="form-subs">enter the 4-digit sent to <span class="phone-number-span">{{ user.email }}</span></div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleEmailVerification">
                                <div class="phone-verify-div">
                                    <input v-for="(digit, index) in 4" :key="index" v-model="emailOtpDigits[index]" class="text-field-60 w-input" maxlength="1" type="text" @input="handleOtpInput($event, index, 'email')" @keydown="handleKeydown($event, index, 'email')" ref="emailInputs" :disabled="verifyingEmail">
                                </div>
                                <a href="#" class="link-72" @click.prevent="resendCode('email')" v-if="!emailResendTimer" :class="{ 'disabled': emailCodeSent }">
                                    Resend code
                                </a>
                                <span v-else class="timer text-muted">Resend available in {{ emailResendTimer }}s</span>
                                <a href="#" class="link-71" @click.prevent="changeEmail">Change my email address</a>
                                <input type="submit" class="form-button w-button" :value="verifyingEmail ? 'Verifying...' : 'Next →'" :disabled="!isEmailOtpComplete || verifyingEmail">
                                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="skipEmailVerification()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">Skip verification -></div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 125px;"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'VerifyPhoneAndEmail',
    props: ['baseUrl'],
    data() {
        return {
            errorMessage: '',
            active_el: 0, // Start with address verification (step 0)
            phoneOtpDigits: ['', '', '', ''],
            emailOtpDigits: ['', '', '', ''],
            phoneResendTimer: 0,
            emailResendTimer: 0,
            phoneCodeSent: false,
            emailCodeSent: false,
            verifyingPhone: false,
            verifyingEmail: false,
            phoneTimerId: null,
            emailTimerId: null,
            isChangingPhone: false,
            isChangingEmail: false,
            updatingPhone: false,
            updatingEmail: false,
            newPhone: {
                area: '',
                prefix: '',
                line: ''
            },
            newEmail: '',
            phoneAttempts: 0,
            emailAttempts: 0,
            phoneCodesSent: 0,
            showPhoneSkip: false,
            showEmailSkip: false,
            // Address validation properties
            validatingAddress: false,
            addressValid: false,
            addressSuggestions: null,
            showAddressForm: false,
            savingAddress: false,
            showAddressSuccess: false,
            addressForm: {
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zip: ''
            },
            allStates: {
                'Alabama': 'AL',
                'Alaska': 'AK',
                'Arizona': 'AZ',
                'Arkansas': 'AR',
                'California': 'CA',
                'Colorado': 'CO',
                'Connecticut': 'CT',
                'Delaware': 'DE',
                'Florida': 'FL',
                'Georgia': 'GA',
                'Hawaii': 'HI',
                'Idaho': 'ID',
                'Illinois': 'IL',
                'Indiana': 'IN',
                'Iowa': 'IA',
                'Kansas': 'KS',
                'Kentucky': 'KY',
                'Louisiana': 'LA',
                'Maine': 'ME',
                'Maryland': 'MD',
                'Massachusetts': 'MA',
                'Michigan': 'MI',
                'Minnesota': 'MN',
                'Mississippi': 'MS',
                'Missouri': 'MO',
                'Montana': 'MT',
                'Nebraska': 'NE',
                'Nevada': 'NV',
                'New Hampshire': 'NH',
                'New Jersey': 'NJ',
                'New Mexico': 'NM',
                'New York': 'NY',
                'North Carolina': 'NC',
                'North Dakota': 'ND',
                'Ohio': 'OH',
                'Oklahoma': 'OK',
                'Oregon': 'OR',
                'Pennsylvania': 'PA',
                'Rhode Island': 'RI',
                'South Carolina': 'SC',
                'South Dakota': 'SD',
                'Tennessee': 'TN',
                'Texas': 'TX',
                'Utah': 'UT',
                'Vermont': 'VT',
                'Virginia': 'VA',
                'Washington': 'WA',
                'West Virginia': 'WV',
                'Wisconsin': 'WI',
                'Wyoming': 'WY'
            }
        }
    },
    computed: {
        ...mapGetters(['getRemainingPrescriptions', 'user', 'getShippingAddress']),
        remainingPrescriptions() {
            return this.getRemainingPrescriptions;
        },
        isPhoneOtpComplete() {
            return this.phoneOtpDigits.every(digit => digit.length === 1);
        },
        isEmailOtpComplete() {
            return this.emailOtpDigits.every(digit => digit.length === 1);
        },
        isValidPhone() {
            const { area, prefix, line } = this.newPhone;

            // Check lengths
            if (area.length !== 3 || prefix.length !== 3 || line.length !== 4) {
                return false;
            }

            // Check if all parts are numbers
            if (!/^\d+$/.test(area) || !/^\d+$/.test(prefix) || !/^\d+$/.test(line)) {
                return false;
            }

            // Check for valid area code
            if (area === '000' || area === '911' || area.startsWith('0') || area.startsWith('1')) {
                return false;
            }

            // Check for valid prefix
            if (prefix === '000' || prefix === '911' || prefix.startsWith('0') || prefix.startsWith('1')) {
                return false;
            }

            // Check for valid line number
            if (line === '0000' || line === '9111') {
                return false;
            }

            return true;
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.newEmail);
        }
    },
    methods: {
        clearError() {
            this.errorMessage = '';
        },

        // Address validation methods
        setAddressFromStore() {
            try {
                this.addressForm.address_line_1 = this.getShippingAddress.addressLine1 || '';
                this.addressForm.address_line_2 = this.getShippingAddress.addressLine2 || '';
                this.addressForm.city = this.getShippingAddress.city || '';
                this.addressForm.state = this.getShippingAddress.state || '';
                this.addressForm.zip = this.getShippingAddress.zip || '';
            } catch (error) {
                console.log(error);
            }
        },

        async validateUserAddress() {
            this.validatingAddress = true;
            this.errorMessage = '';
            
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/address/validate/${this.user.id}`);
                
                if (response.data.valid) {
                    this.addressValid = response.data.valid;
                    if (response.data.valid) {
                        this.moveToPhoneVerification();
                    } else if (response.data.suggestions) {
                        this.addressSuggestions = response.data.suggestions;
                    }
                } else {
                    this.errorMessage = 'Unable to validate address. Please enter your address manually.';
                    this.showAddressForm = true;
                }
            } catch (error) {
                console.error('Error validating address:', error);
                this.errorMessage = 'Unable to validate address. Please enter your address manually.';
                this.showAddressForm = true;
            } finally {
                this.validatingAddress = false;
            }
        },

        async acceptSuggestedAddress() {
            this.savingAddress = true;
            this.errorMessage = '';
            
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/ship-address`, this.addressSuggestions);
                
                if (response.data.status === 'success') {
                    await this.$store.dispatch('saveShippingDetails', this.addressSuggestions);
                    this.addressValid = true;
                    this.moveToPhoneVerification();
                } else {
                    this.errorMessage = 'Failed to save address. Please try again.';
                }
            } catch (error) {
                console.error('Error saving suggested address:', error);
                this.errorMessage = error.response?.data?.message || 'Failed to save address. Please try again.';
            } finally {
                this.savingAddress = false;
            }
        },

        async validateAndSaveAddress() {
            this.savingAddress = true;
            this.errorMessage = '';
            
            try {
                const validationResponse = await this.$axios.post(`${this.baseUrl}/api/address/validate`, this.addressForm);
                
                if (validationResponse.data.valid) {
                    const saveResponse = await this.$axios.post(`${this.baseUrl}/api/ship-address`, this.addressForm);
                    
                    if (saveResponse.data.status === 'success') {
                        await this.$store.dispatch('saveShippingDetails', this.addressForm);
                        this.addressValid = true;
                        this.showAddressForm = false;
                        this.moveToPhoneVerification();
                    } else {
                        this.errorMessage = 'Failed to save address. Please try again.';
                    }
                } else if (validationResponse.data.suggestions) {
                    this.addressSuggestions = validationResponse.data.suggestions;
                    this.showAddressForm = false;
                    this.errorMessage = 'We found a suggested correction for your address.';
                } else {
                    this.errorMessage = 'Please check your address and try again.';
                }
            } catch (error) {
                console.error('Error validating/saving address:', error);
                this.errorMessage = error.response?.data?.message || 'Failed to validate address. Please try again.';
            } finally {
                this.savingAddress = false;
            }
        },

        moveToPhoneVerification() {
            this.active_el = 1;
            this.sendCode('phone');
        },

        skipAddressVerification() {
            this.moveToPhoneVerification();
        },

        handleOtpInput(event, index, type) {
            const value = event.target.value;
            const digits = type === 'phone' ? this.phoneOtpDigits : this.emailOtpDigits;
            const inputs = type === 'phone' ? this.$refs.phoneInputs : this.$refs.emailInputs;

            // Only allow numbers
            if (!/^\d*$/.test(value)) {
                digits[index] = '';
                return;
            }

            // Auto-advance to next input
            if (value && index < 3) {
                inputs[index + 1].focus();
            }
        },

        handleKeydown(event, index, type) {
            const digits = type === 'phone' ? this.phoneOtpDigits : this.emailOtpDigits;
            const inputs = type === 'phone' ? this.$refs.phoneInputs : this.$refs.emailInputs;

            if (event.key === 'Backspace' && !digits[index] && index > 0) {
                digits[index - 1] = '';
                inputs[index - 1].focus();
            }
        },

        validatePhoneInput(event, field) {
            const value = event.target.value.replace(/\D/g, '');
            this.newPhone[field] = value;

            // Auto-advance to next field when current field is complete
            const input = event.target;
            if (value.length === input.maxLength) {
                if (field === 'area') {
                    this.$refs.prefixInput.focus();
                } else if (field === 'prefix') {
                    this.$refs.lineInput.focus();
                }
            }
        },

        startResendTimer(type) {
            const timerProp = type === 'phone' ? 'phoneResendTimer' : 'emailResendTimer';
            const timerIdProp = type === 'phone' ? 'phoneTimerId' : 'emailTimerId';

            this[timerProp] = 60;

            if (this[timerIdProp]) {
                clearInterval(this[timerIdProp]);
            }

            this[timerIdProp] = setInterval(() => {
                if (this[timerProp] > 0) {
                    this[timerProp]--;
                } else {
                    clearInterval(this[timerIdProp]);
                }
            }, 1000);
        },

        async resendCode(type) {
            if ((type === 'phone' && this.phoneResendTimer > 0) ||
                (type === 'email' && this.emailResendTimer > 0)) {
                return;
            }

            try {
                await this.sendCode(type);
                this.startResendTimer(type);
                if (type === 'phone') {
                    this.phoneCodeSent = true;
                    this.phoneCodesSent++;
                    
                    if (this.phoneCodesSent >= 2) {
                        this.active_el = 2;
                        await this.sendCode('email');
                    }
                    
                    setTimeout(() => {
                        this.phoneCodeSent = false;
                    }, 3000);
                } else {
                    this.emailCodeSent = true;
                    setTimeout(() => {
                        this.emailCodeSent = false;
                    }, 3000);
                }
            } catch (error) {
                console.error('Error resending code:', error);
                this.errorMessage = error.response?.data?.message || 'Error sending code. Please try again.';
            }
        },

        async handlePhoneVerification() {
            if (!this.isPhoneOtpComplete || this.verifyingPhone) return;

            this.verifyingPhone = true;
            this.errorMessage = '';
            try {
                const code = this.phoneOtpDigits.join('');
                await this.verifyCode('phone', code);
                this.phoneAttempts = 0;
                this.active_el = 2;
                await this.sendCode('email');
            } catch (error) {
                console.error('Error verifying phone:', error);
                this.phoneAttempts++;
                this.errorMessage = error.response?.data?.message || 'Invalid verification code. Please try again.';
                this.phoneOtpDigits = ['', '', '', ''];
                
                if (this.phoneAttempts >= 2) {
                    this.showPhoneSkip = true;
                    this.skipPhoneVerification();
                }
            } finally {
                this.verifyingPhone = false;
            }
        },

        async handleEmailVerification() {
            if (!this.isEmailOtpComplete || this.verifyingEmail) return;

            this.verifyingEmail = true;
            this.errorMessage = '';
            try {
                const code = this.emailOtpDigits.join('');
                await this.verifyCode('email', code);
                this.emailAttempts = 0;
                this.pushToMedForm();
            } catch (error) {
                this.emailAttempts++;
                this.errorMessage = error.response?.data?.message || 'Invalid verification code. Please try again.';
                this.emailOtpDigits = ['', '', '', ''];
                
                if (this.emailAttempts >= 2) {
                    this.showEmailSkip = true;
                    this.$router.push({ name: 'HomePage' });
                }
            } finally {
                this.verifyingEmail = false;
            }
        },

        pushToMedForm() {
            try {
                let order = this.remainingPrescriptions[0];
                console.log(order);
                this.$router.push({
                    name: 'QuestionFormLoaderUpdated',
                    params: {
                        id: order.orderId
                    }
                });
            } catch (error) {
                this.$router.push({
                    name: 'HomePage'
                });
            }
        },

        skipPhoneVerification() {
            this.active_el = 2;
            this.sendCode('email');
        },

        skipEmailVerification() {
            this.$router.push({ name: 'HomePage' });
        },

        changePhone() {
            this.isChangingPhone = true;
            this.phoneAttempts = 0;
            this.showPhoneSkip = false;
            this.phoneOtpDigits = ['', '', '', ''];
            this.errorMessage = '';
            if (this.phoneTimerId) {
                clearInterval(this.phoneTimerId);
                this.phoneResendTimer = 0;
            }
        },

        changeEmail() {
            this.isChangingEmail = true;
            this.emailAttempts = 0;
            this.showEmailSkip = false;
            this.emailOtpDigits = ['', '', '', ''];
            this.errorMessage = '';
            if (this.emailTimerId) {
                clearInterval(this.emailTimerId);
                this.emailResendTimer = 0;
            }
        },

        cancelPhoneChange() {
            this.isChangingPhone = false;
            this.newPhone = {
                area: '',
                prefix: '',
                line: ''
            };
            this.errorMessage = '';
        },

        cancelEmailChange() {
            this.isChangingEmail = false;
            this.newEmail = '';
            this.errorMessage = '';
        },

        async updatePhoneNumber() {
            if (!this.isValidPhone || this.updatingPhone) return;

            this.updatingPhone = true;
            this.errorMessage = '';
            try {
                const formattedPhone = `${this.newPhone.area}${this.newPhone.prefix}${this.newPhone.line}`;
                await this.$axios.post(`${this.baseUrl}/api/update-phone`, {
                    phone: formattedPhone
                });

                await this.$store.dispatch('updateUserPhone', formattedPhone);

                this.isChangingPhone = false;
                this.phoneOtpDigits = ['', '', '', ''];
                await this.sendCode('phone');
            } catch (error) {
                console.error('Error updating phone:', error);
                this.errorMessage = error.response?.data?.message || 'Error updating phone number. Please try again.';
            } finally {
                this.updatingPhone = false;
            }
        },

        async updateEmailAddress() {
            if (!this.isValidEmail || this.updatingEmail) return;

            this.updatingEmail = true;
            this.errorMessage = '';
            try {
                await this.$axios.post(`${this.baseUrl}/api/update-email`, {
                    email: this.newEmail
                });

                await this.$store.dispatch('updateUserEmail', this.newEmail);

                this.isChangingEmail = false;
                this.emailOtpDigits = ['', '', '', ''];
                await this.sendCode('email');
            } catch (error) {
                console.error('Error updating email:', error);
                this.errorMessage = error.response?.data?.message || 'Error updating email address. Please try again.';
            } finally {
                this.updatingEmail = false;
            }
        },

        async sendCode(type) {
            this.errorMessage = '';
            try {
                const typeValue = type === 'phone' ? 1 : 2;
                await this.$axios.post(`${this.baseUrl}/api/send-code/${typeValue}`);
                
                if (type === 'phone') {
                    this.phoneCodesSent++;
                    if (this.phoneCodesSent >= 2) {
                        this.active_el = 2;
                        await this.sendCode('email');
                    }
                }
            } catch (error) {
                console.error('Error sending code:', error);
                this.errorMessage = error.response?.data?.message || 'Error sending verification code. Please try again.';
                throw error;
            }
        },

        async verifyCode(type, code) {
            this.errorMessage = '';
            try {
                const typeValue = type === 'phone' ? 1 : 2;
                await this.$axios.post(`${this.baseUrl}/api/verify-code`, {
                    type: typeValue,
                    code
                });
            } catch (error) {
                console.error('Error verifying code:', error);
                this.errorMessage = error.response?.data?.message || 'Error verifying code. Please try again.';
                throw error;
            }
        }
    },
    mounted() {
        this.setAddressFromStore();
        this.validateUserAddress();
    },
    beforeDestroy() {
        if (this.phoneTimerId) clearInterval(this.phoneTimerId);
        if (this.emailTimerId) clearInterval(this.emailTimerId);
    }
}
</script>

<style scoped>
.error-message {
    color: red;
    margin-top: 10px;
    padding: 10px;
    background-color: #FEE2E2;
    border: 1px solid #FCA5A5;
    border-radius: 4px;
    font-size: 14px;
}

.success-message {
    margin-top: 10px;
    padding: 10px;
    background-color: #D1FAE5;
    border: 1px solid #A7F3D0;
    color: #059669;
    border-radius: 4px;
    font-size: 14px;
}

/* Progress indicator styles */
.progress-section {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.progress-container {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
}

.step-text {
    font-size: 16px;
    color: #495057;
}

/* Address validation specific styles */
.validation-loading {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #666;
}

.address-suggestions {
    background-color: #F3F4F6;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
}

.suggestion-header {
    font-weight: bold;
    margin-bottom: 10px;
    color: #374151;
}

.suggested-address {
    background-color: white;
    border: 1px solid #E5E7EB;
    border-radius: 4px;
    padding: 15px;
    margin: 20px 0;
    line-height: 1.5;
}

.address-confirmed {
    text-align: center;
    padding: 20px;
}

.confirmation-header {
    font-size: 18px;
    font-weight: bold;
    color: #059669;
    margin-bottom: 15px;
}

.auto-advance-message {
    font-size: 14px;
    color: #6B7280;
    font-style: italic;
}

.address-form-row {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    align-items: center;
}

.address-field {
    flex: 2;
}

.apt-field {
    flex: 1;
}

.city-field {
    flex: 1;
}

.state-field {
    flex: 1;
}

.zip-field {
    flex: 1;
}

.button-group {
    display: flex;
    gap: 15px;
    margin-top: 20px;
    flex-wrap: wrap;
}

.form-button.secondary {
    background-color: transparent;
    border: 1px solid #3B82F6;
    color: #3B82F6;
}

.form-button.secondary:hover {
    background-color: #3B82F6;
    color: white;
}

/* Responsive design */
@media only screen and (max-width: 767px) {
    .questions-div {
        width: 93%;
        padding: 50px 0% 80px;
        margin: 0 auto !important;
    }
    
    .button-group {
        flex-direction: column;
    }
    
    .address-form-row {
        flex-direction: column;
        gap: 8px;
        margin-bottom: 12px;
    }
    
    .address-field,
    .apt-field,
    .city-field,
    .state-field,
    .zip-field {
        flex: 1;
        width: 100%;
    }
    
    .address-form-row input,
    .address-form-row select {
        font-size: 14px;
        padding: 8px 6px;
        width: 100%;
    }
}
.text-field-59999 {
    width: 100% !important;
}
</style>